"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferResponseOffer = void 0;
const tslib_1 = require("tslib");
const BaseProposition_1 = tslib_1.__importDefault(require("../../propositions/BaseProposition"));
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const PropositionDuration_1 = tslib_1.__importDefault(require("../../enums/PropositionDuration"));
const class_transformer_1 = require("class-transformer");
const GetNextBestOfferResponseOfferIncentiveV2_1 = tslib_1.__importDefault(require("../v2/GetNextBestOfferResponseOfferIncentiveV2"));
const PropositionProduct_1 = tslib_1.__importDefault(require("../../propositions/PropositionProduct"));
class GetOfferResponseOffer extends BaseProposition_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'Offer Identifier. Generated by the Offer Store when a propositions is matched with a profile. This identifier is unique and should be used to update offer feedbacks or retrieve specific offers.',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponseOffer.prototype, "offerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(PropositionDuration_1.default)),
    (0, base_models_1.Docs)({
        example: PropositionDuration_1.default.FLEX,
        description: 'Proposition duration',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponseOffer.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetNextBestOfferResponseOfferIncentiveV2_1.default),
    tslib_1.__metadata("design:type", Array)
], GetOfferResponseOffer.prototype, "incentives", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PropositionProduct_1.default),
    tslib_1.__metadata("design:type", Array)
], GetOfferResponseOffer.prototype, "products", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: 'e82bfe67-bb59-4c77-93f5-95a60bd91146',
        description: 'Profile id that is connected to the given offer',
    }),
    tslib_1.__metadata("design:type", String)
], GetOfferResponseOffer.prototype, "profileId", void 0);
exports.GetOfferResponseOffer = GetOfferResponseOffer;
